// extracted by css-extract-rspack-plugin
export default {"container":"Description-module__container__X7KkqCg","compact":"Description-module__compact__XSjqexq"};